export const ignoreErrors: RegExp[] = [
  /'get' on proxy: property 'javaEnabled' is a read-only and non-configurable data property on the proxy target but the proxy did not return its actual value/i,
  /Non-Error exception captured/i,
  /NetworkError when attempting to fetch resource\./i,
  /code 502/i,
  /provider destroyed/i, // https://app.asana.com/0/1206404689006418/1208803871461816/f
  /Cannot read properties of null (reading 'setAttribute')/i, // https://app.asana.com/0/1206404689006418/1208803871461820/f
  /[vidstack] media not ready/i, // https://app.asana.com/0/1206404689006418/1208955085567860/f
  /play() failed because the user didn't interact with the document first/i, // https://app.asana.com/1/720735399471482/project/1206404689006418/task/1208955081847841?focus=true
  /Setting the playback rate is not enabled for this video./i, // https://app.asana.com/1/720735399471482/project/1208637824424842/task/1210184531103697/f
]